import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=fb7f9550&scoped=true"
import script from "./order.js?vue&type=script&lang=js&external"
export * from "./order.js?vue&type=script&lang=js&external"
import style0 from "./order.scss?vue&type=style&index=0&id=fb7f9550&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7f9550",
  null
  
)

export default component.exports